import React, { useState } from "react";
import { apiService } from "./services/apiService";
import { FaPaperPlane, FaEnvelopeOpenText, FaArrowLeft } from "react-icons/fa";

function EmailBroadcast({ onBack }) {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  // Button remains disabled until both subject and message details are drafted
  const isFormValid = subject.trim() !== "" && message.trim() !== "";

  const handleSendBroadcast = async (e) => {
    e.preventDefault();
    if (!isFormValid) return;

    setSending(true);
    try {
      const payload = {
        subject: subject.trim(),
        message: message.trim()
      };

      const result = await apiService.sendBroadcastEmail(payload);

      if (result.success) {
        alert(`✉️ Success! ${result.message || "Email broadcast sent successfully to all active students."}`);
        // Reset form on success
        setSubject("");
        setMessage("");
      } else {
        alert("❌ Failed to send broadcast: " + result.message);
      }
    } catch (err) {
      console.error("Failed to broadcast message: ", err);
      alert("❌ Broadcast delivery pipeline failed: " + err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="rp-page" style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      {/* ── Header ── */}
      <div className="rp-header-card" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "24px", padding: "20px", background: "#ffffff", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", marginBottom: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <div className="rp-header-icon" style={{ backgroundColor: "#e8eaf6", color: "#1a237e", padding: "12px", borderRadius: "8px" }}>
            <FaEnvelopeOpenText size={22} />
          </div>
          <div>
            <h2 className="rp-title" style={{ margin: 0, color: "#1a237e", fontSize: "20px" }}>Email Broadcaster</h2>
            <p className="rp-subtitle" style={{ margin: "4px 0 0 0", color: "#666", fontSize: "13px" }}>Dispatch customized notifications to all active library students</p>
          </div>
        </div>
        
        <button 
          className="rp-btn-back" 
          onClick={onBack} 
          style={{ display: "inline-flex", alignItems: "center", gap: "6px", cursor: "pointer", background: "#f5f5f5", border: "1px solid #ddd", borderRadius: "6px", padding: "8px 12px", fontWeight: "600", fontSize: "13px" }}
        >
          <FaArrowLeft /> Back to Dashboard
        </button>
      </div>

      {/* ── Main Form Card ── */}
      <div className="rp-card" style={{ background: "#ffffff", padding: "30px", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
        <form onSubmit={handleSendBroadcast} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontWeight: "600", color: "#37474f", fontSize: "14px" }}>Email Notification Subject *</label>
            <input
              type="text"
              placeholder="e.g., Important Notice: Library Schedule Changes during Holidays"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              disabled={sending}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
                outline: "none",
                boxSizing: "border-box"
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <label style={{ fontWeight: "600", color: "#37474f", fontSize: "14px" }}>Email Message Body *</label>
            <textarea
              rows="10"
              placeholder="Type your announcement, updates, or instructions here..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              disabled={sending}
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
                fontFamily: "inherit",
                resize: "vertical",
                outline: "none",
                boxSizing: "border-box"
              }}
            />
          </div>

          {/* ── Submit Action ── */}
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
            <button
              type="submit"
              disabled={!isFormValid || sending}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: isFormValid && !sending ? "#1a237e" : "#bdbdbd",
                color: "#ffffff",
                border: "none",
                padding: "12px 24px",
                borderRadius: "6px",
                fontWeight: "600",
                fontSize: "14px",
                cursor: isFormValid && !sending ? "pointer" : "not-allowed",
                transition: "all 0.2s"
              }}
            >
              <FaPaperPlane />
              {sending ? "Sending Notifications..." : "Send Email"}
            </button>
          </div>
          
        </form>
      </div>
    </div>
  );
}

export default EmailBroadcast;